import { Switch, SwitchProps } from '@ui/lib/park/ui/switch';
import { useTranslation } from 'next-i18next';

import { useTradingPair } from '../../store/useTradingPair';

export const CurrentTradingPairToggle = (p: SwitchProps & {}) => {
  const { t } = useTranslation();
  const tradingPair = useTradingPair((v) => v.useTradingPair());

  return (
    <Switch
      textStyle="v2.meta"
      color="v2.text.muted"
      {...p}
      data-cy="CurrentTradingPairToggle"
    >
      {t('common.Show {token}', {
        token: tradingPair.baseSymbol,
      })}
    </Switch>
  );
};
